import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FileUploader } from 'ng2-file-upload';


const URL = 'https://evening-anchorage-3159.herokuapp.com/api/';


@Component({
  selector: 'app-uploader',
  templateUrl: './uploader.component.html',
  styleUrls: ['./uploader.component.css']
})
export class UploaderComponent implements OnInit {
  uploader: FileUploader;
  hasBaseDropZoneOver: boolean;
  hasAnotherDropZoneOver: boolean;
  response: string;
  file: any;
  @Input() hasError: boolean = false;
  @Output() onFileDropChange: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('fileInput') input!: ElementRef<HTMLElement>;

  ngOnInit(): void {
  }

  constructor(private snackbar:MatSnackBar) {
    this.uploader = new FileUploader({
      url: URL,
      disableMultipart: true, // 'DisableMultipart' must be 'true' for formatDataFunction to be called.
      formatDataFunctionIsAsync: true,
      formatDataFunction: async (item: any) => {
        return new Promise((resolve, reject) => {
          resolve({
            name: item._file.name,
            length: item._file.size,
            contentType: item._file.type,
            date: new Date()
          });
        });
      }
    });

    this.hasBaseDropZoneOver = false;
    this.hasAnotherDropZoneOver = false;

    this.response = '';

    this.uploader.response.subscribe(res => this.response = res);
  }

  onFileDrop($event: any) {
    if (this.uploader.queue[0].file.type?.toLowerCase() != "text/csv") {
      this.snackbar.open('Only CSV files are allowed',"Dismiss", {
        duration: 5000,
        panelClass: ['white-snackbar']
      });
    } else {
      this.file = this.uploader.queue[0];
      this.onFileDropChange.emit(this.uploader.queue[0].file);
    }
    this.uploader.clearQueue();
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

}
